// components/ProfileCard.jsx
import { Trash2, UserRoundCheck, UserRoundPen } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../context/ToastContext";

const ProfileCard = ({ user }) => {
  const navigate = useNavigate();
  const toast = useToast(); // Get the toast functions

  return (
    <div className="bg-white p-6 rounded-2xl shadow-md flex items-start gap-6">
      {/* Profile Image */}
      <img
        src={user.image}
        alt="Profile"
        className="w-40 md:w-48 object-cover rounded-xl bg-gray-500"
      />

      {/* Main Details */}
      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="">
          <p className="mb-5">
            <strong>Name:</strong> {user.displayName}
          </p>
          <p className="mb-5">
            <strong>Email:</strong> {user.email}
          </p>
          <p className="mb-5">
            <strong>Contact Number:</strong> {user.contactNumber}
          </p>
        </div>
        <div>
          <p className="mb-5">
            <strong>Role:</strong> {user?.userRole?.value}
          </p>
          <p className="mb-5">
            <strong>ID No.:</strong> {user.id}
          </p>
          <p className="mb-5">
            <strong>Date of Joining:</strong> {user.joiningDate}
          </p>
        </div>

        <div className="relative hidden">
          <div className="absolute top-0 right-0 flex space-x-2">
            <button
              //onClick={onEdit}
              className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
              aria-label="Edit"
            >
              <UserRoundPen className="h-5 w-5" />
            </button>
            <button
              // onClick={onDelete}
              className="p-2 rounded-full bg-red-100 text-red-600 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
              aria-label="Delete"
            >
              <Trash2 className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="ml-2 hidden">
          <p className="mb-5">
            <strong>Most time taken:</strong> {user.maxTime}
          </p>
          <p className="mb-5">
            <strong>Best time:</strong> {user.minTime}
          </p>
          <p className="mb-5">
            <strong>Current Status:</strong>{" "}
            <span className="text-green-600 font-medium">{user.status}</span>
          </p>
        </div>
      </div>
      <div className="relative">
        {/* Action Buttons Container */}
        <div className="absolute top-0 right-0 flex space-x-2">
          {/* Edit Button with Tooltip */}
          <div className="relative group">
            {" "}
            {/* Parent for tooltip functionality */}
            <button
              onClick={(e) => {
                e.preventDefault();
                // toast.info("Form approved successfully!");
                navigate(
                  `/validators/change-validator-password?user=${user.id}`
                );
              }}
              className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 cursor-pointer"
              aria-label="Edit"
            >
              <UserRoundPen className="h-5 w-5" />
            </button>
            {/* Tooltip Content */}
            <span
              className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2
                         px-3 py-1 bg-gray-700 text-white text-xs rounded-md shadow-sm
                         opacity-0 group-hover:opacity-100 transition-opacity duration-200
                         pointer-events-none whitespace-nowrap z-10"
            >
              {" "}
              {/* z-10 to ensure it's on top */}
              Change Password
              {/* Optional: Tooltip Arrow */}
              <span className="absolute left-1/2 top-full h-0 w-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-700 -translate-x-1/2"></span>
            </span>
          </div>

          {/* Delete Button with Tooltip */}
          <div className="relative group hidden">
            {" "}
            {/* Parent for tooltip functionality */}
            <button
              //onClick={onDelete}
              className="p-2 rounded-full bg-red-100 text-red-600 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 cursor-pointer"
              aria-label="Delete"
            >
              <Trash2 className="h-5 w-5" />
            </button>
            {/* Tooltip Content */}
            <span
              className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2
                         px-3 py-1 bg-gray-700 text-white text-xs rounded-md shadow-sm
                         opacity-0 group-hover:opacity-100 transition-opacity duration-200
                         pointer-events-none whitespace-nowrap z-10"
            >
              Delete User
              {/* Optional: Tooltip Arrow */}
              <span className="absolute left-1/2 top-full h-0 w-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-700 -translate-x-1/2"></span>
            </span>
          </div>
        </div>
      </div>

      {/* Right Side Stats */}
      <div className="flex flex-col gap-4 hidden">
        <div className="border p-4 rounded-lg flex flex-col items-center justify-center w-48">
          <p className="text-xl font-semibold">{user.avgTime}</p>
          <p className="text-sm text-gray-600 text-center">
            Average Form Filling Time
          </p>
        </div>
        <div className="border p-4 rounded-lg flex flex-col items-center justify-center w-48">
          <p className="text-xl font-semibold">{user.totalFilled}</p>
          <p className="text-sm text-gray-600 text-center">
            Total Forms Filled
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
